module.exports = __webpack_public_path__ + "img/Shawarma_Meal_Chicken.e1a6cfad.jpg";